import { useState, useCallback } from "react";

export function useAddressFlow() {
  const [flowState, setFlowState] = useState({
    visible: false,
    step: "map", // "map" | "form"
    resolve: null,

    locationData: null,
    formData: null,
    editingAddressId: null,
  });

  const openAddressFlow = useCallback((initialData = {}) => {
    const hasValidCoords =
      initialData?.coordinates &&
      initialData.coordinates.latitude !== 0 &&
      initialData.coordinates.longitude !== 0;

    // initialLocationData can seed the map pin even when starting on "map" step
    const seedLocation = initialData?.initialLocationData || null;

    return new Promise((resolve) => {
      setFlowState({
        visible: true,
        resolve,
        step: hasValidCoords ? "form" : "map",
        locationData: hasValidCoords
          ? {
              latLng: {
                lat: initialData.coordinates.latitude,
                lng: initialData.coordinates.longitude,
              },
              address: null,
              selectedLabel: "",
            }
          : seedLocation,
        formData: initialData || null,
        editingAddressId: initialData?.id || null,
      });
    });
  }, []);

  const closeFlow = useCallback(
    (result) => {
      if (flowState?.resolve) {
        flowState.resolve(result);
      }
      setFlowState((prev) => ({ ...prev, visible: false }));
    },
    [flowState],
  );

  return {
    flowState,
    setFlowState,
    openAddressFlow,
    closeFlow,
  };
}
